import React, { useState } from 'react';
import { useCart } from './context/cart';
import { useNavigate } from 'react-router-dom';
import Button_green from './UI/Button_green/Button_green';
import Input from './UI/Input/Input';
import axios from 'axios';

const Cart = () => {
    const { cartItems, updateQuantity, removeFromCart, getTotalPrice, clearCart } = useCart();
    const navigate = useNavigate();
    
    const [orderForm, setOrderForm] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        city: '',
        comment: ''
    });
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [orderSuccess, setOrderSuccess] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setOrderForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmitOrder = async (e) => {
        e.preventDefault();
        
        // Проста валідація
        if (!orderForm.firstName || !orderForm.lastName || !orderForm.phone) {
            alert('Будь ласка, заповніть обов\'язкові поля: Ім\'я, Прізвище та Телефон');
            return;
        }

        if (cartItems.length === 0) {
            alert('Кошик порожній');
            return;
        }

        setIsSubmitting(true);

        try {
            const orderData = {
                type: 'create_order',
                customer: orderForm,
                items: cartItems,
                total: getTotalPrice(),
                orderDate: new Date().toISOString()
            };

            const response = await axios.post('https://td-budkom.com.ua/orderpost.php', orderData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });

            console.log(response);

            if (response.data && response.data.success) {
                clearCart();
                navigate('/Confirm');
            } else {
                alert('Помилка при оформленні замовлення. Спробуйте ще раз.');
            }
        } catch (error) {
            console.error('Error submitting order:', error);
            alert('Помилка при відправці замовлення');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="cart-page" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <button 
                onClick={() => navigate(-1)}
                style={{ 
                    marginBottom: '20px', 
                    padding: '8px 16px', 
                    border: '1px solid #ddd',
                    background: 'white',
                    cursor: 'pointer',
                    borderRadius: '4px',
                    fontFamily: 'Inter, sans-serif'
                }}
            >
                ← Назад
            </button>

            <h1 style={{ marginBottom: '30px', fontFamily: 'Inter, sans-serif' }}>Кошик</h1>

            {cartItems.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', fontFamily: 'Inter, sans-serif' }}>
                    <h3 style={{ fontFamily: 'Inter, sans-serif' }}>Ваш кошик порожній</h3>
                    <Button_green onClick={() => navigate('/')} style={{ marginTop: '20px' }}>
                        ПРОДОВЖИТИ ПОКУПКИ
                    </Button_green>
                </div>
            ) : (
                <div className="cart-content" style={{ display: 'grid', gridTemplateColumns: '1fr 400px', gap: '40px' }}>
                    {/* Список товарів */}
                    <div className="cart-items">
                        <h2 style={{ marginBottom: '20px', fontFamily: 'Inter, sans-serif' }}>Товари в кошику:</h2>
                        {cartItems.map((item, index) => (
                            <div key={`${item.id}-${item.selectedSize}`} className="cart-item" style={{
                                display: 'flex',
                                gap: '15px',
                                padding: '15px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                marginBottom: '15px',
                                alignItems: 'center'
                            }}>
                                {item.image && (
                                    <img 
                                        src={item.image} 
                                        alt={item.name}
                                        style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '4px' }}
                                    />
                                )}
                                
                                <div style={{ flex: 1 }}>
                                    <h4 style={{ fontFamily: 'Inter, sans-serif' }}>{item.name}</h4>
                                    <p style={{ fontFamily: 'Inter, sans-serif' }}>Розмір: {item.selectedSize}</p>
                                    <p style={{ color: '#4CAF50', fontWeight: 'bold', fontFamily: 'Inter, sans-serif' }}>
                                        {parseFloat(item.price).toLocaleString()} ₴
                                    </p>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <button 
                                        onClick={() => updateQuantity(item.id, item.selectedSize, item.quantity - 1)}
                                        style={{
                                            padding: '5px 10px',
                                            border: '1px solid #ddd',
                                            background: 'white',
                                            cursor: 'pointer',
                                            borderRadius: '4px'
                                        }}
                                    >
                                        -
                                    </button>
                                    <span style={{ minWidth: '40px', textAlign: 'center', fontFamily: 'Inter, sans-serif' }}>{item.quantity}</span>
                                    <button 
                                        onClick={() => updateQuantity(item.id, item.selectedSize, item.quantity + 1)}
                                        style={{
                                            padding: '5px 10px',
                                            border: '1px solid #ddd',
                                            background: 'white',
                                            cursor: 'pointer',
                                            borderRadius: '4px'
                                        }}
                                    >
                                        +
                                    </button>
                                </div>

                                <div style={{ textAlign: 'right', minWidth: '100px' }}>
                                    <div style={{ fontWeight: 'bold', fontFamily: 'Inter, sans-serif' }}>
                                        {(parseFloat(item.price) * item.quantity).toLocaleString()} ₴
                                    </div>
                                    <button 
                                        onClick={() => removeFromCart(item.id, item.selectedSize)}
                                        style={{
                                            marginTop: '5px',
                                            padding: '4px 8px',
                                            border: 'none',
                                            background: '#f44336',
                                            color: 'white',
                                            cursor: 'pointer',
                                            borderRadius: '4px',
                                            fontSize: '12px',
                                            fontFamily: 'Inter, sans-serif'
                                        }}
                                    >
                                        Видалити
                                    </button>
                                </div>
                            </div>
                        ))}
                        
                        <div style={{ textAlign: 'right', fontSize: '20px', fontWeight: 'bold', marginTop: '20px', fontFamily: 'Inter, sans-serif' }}>
                            Разом: {getTotalPrice().toLocaleString()} ₴
                        </div>
                    </div>

                    {/* Форма оформлення замовлення */}
                    <div className="order-form">
                        <h2 style={{ marginBottom: '20px', fontFamily: 'Inter, sans-serif' }}>Оформлення замовлення:</h2>
                        <form onSubmit={handleSubmitOrder}>
                            <div style={{ marginBottom: '15px' }}>
                                <Input
                                    type="text"
                                    name="firstName"
                                    placeholder="Ім'я *"
                                    value={orderForm.firstName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <Input
                                    type="text"
                                    name="lastName"
                                    placeholder="Прізвище *"
                                    value={orderForm.lastName}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <Input
                                    type="tel"
                                    name="phone"
                                    placeholder="Номер телефону *"
                                    value={orderForm.phone}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <Input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    value={orderForm.email}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <Input
                                    type="text"
                                    name="city"
                                    placeholder="Місто"
                                    value={orderForm.city}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div style={{ marginBottom: '20px' }}>
                                <textarea
                                    name="comment"
                                    placeholder="Коментар до замовлення"
                                    value={orderForm.comment}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        minHeight: '80px',
                                        resize: 'vertical',
                                        fontFamily: 'Inter, sans-serif'
                                    }}
                                />
                            </div>

                            <Button_green 
                                type="submit" 
                                disabled={isSubmitting}
                                style={{ width: '100%' }}
                            >
                                {isSubmitting ? 'ОФОРМЛЮЄМО...' : 'ОФОРМИТИ ЗАМОВЛЕННЯ'}
                            </Button_green>

                            <p style={{ fontSize: '12px', color: '#666', marginTop: '10px', fontFamily: 'Inter, sans-serif' }}>
                                * Обов'язкові поля
                            </p>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Cart;